import { handle420 } from 'apis/HandleError';
import { fetchdata } from 'apis/FetchData';
import { apiConfig } from 'config';

export function softwareUpdate(deviceID, softwareID, scheduleTime) {
  let url = apiConfig.cmServiceDevicesSoftwareUpdate(deviceID);
  return fetchdata(url, { method: 'POST', body: JSON.stringify({ sw_identifier: softwareID, schedule: scheduleTime }) }) //.then(() => {throw new Error("message")})
    .catch((e) => {
      console.log('fetch data error = ' + e.message);
      switch (e.message) {
        case '420':
          handle420();
          break;
        case '403':
          //console.log("Device is offline, software update cannot be performed");
          throw new Error('Device is offline, software update cannot be performed');
        case '404':
          console.log('Device with id "' + deviceID + '" does not exist');
          throw new Error('Cannot find device with ID' + deviceID);
        default:
          throw new Error('An unknown error occurred');
      }
      return;
    });
}
